import { useCallback } from 'react';
import { useActions } from '@frontend/jetlend-core/src/hooks/useActions';
import useStoreHandler from '@frontend/jetlend-core/src/hooks/useStoreHandler';
import useFormHandler from '@frontend/jetlend-core/src/hooks/useFormHandler';
import ConnectedSmsCodeApproveContent from '@app/components/ConnectedSmsCodeApproveContent/ConnectedSmsCodeApproveContent';
import styles from './ScoringCode.module.scss';
import ScoringInProgress from '../ScoringInProgress/ScoringInProgress';
import {
    limitPrescoringRegisterFormHandler,
    limitPrescoringStoreHandler,
} from '@app/ducks/borrowers/borrowers';
import {
    BorrowerLimitPrescoringModalStage,
    BorrowerLimitPrescoringStoreData,
} from '@app/models/borrowers/limitPrescoring';

export interface IProps {
    /**
     * Флаг для скрытия лоадера
     */
    hideLoader?: boolean;
}

/**
 * Компонент для ввода кода подтверждения из смс
 */
export default function ScoringCode({
    hideLoader = false,
}: IProps) {
    const changeStorage = useActions(limitPrescoringStoreHandler.update);
    const [ data ] = useStoreHandler<BorrowerLimitPrescoringStoreData>(limitPrescoringStoreHandler);
    const {
        reset,
    } = useFormHandler(limitPrescoringRegisterFormHandler);

    const didCloseClicked = useCallback(() => {
        /**
         * Сбрасываем данные формы
         */
        reset();
        /**
         * Возвращаемся на стадию ввода контактов
         */
        changeStorage({
            ...data,
            stage: BorrowerLimitPrescoringModalStage.EMAIL_CONFIRM,
        });
    }, [ changeStorage, data, reset ]);

    return (
        <div className={styles['content']}>
            <div className={styles['code-form']}>
                <ConnectedSmsCodeApproveContent allowRetry onClose={didCloseClicked} />
            </div>
            {!hideLoader && <ScoringInProgress isLoading />}
        </div>
    );
}